"use client";

import { use } from "react";

import { JwtContext } from "../components/jwt-context";

export const useJwt = () => {
  const context = use(JwtContext);
  if (context === undefined) {
    throw new Error("useJwt must be used within a JwtProvider");
  }
  return context;
};
